import { useState } from 'react'
import { Modal, Button } from '../common'
import styles from './AddConfirmToast.module.css'

interface RemoveConfirmModalProps {
  action: 'remove-collection' | 'remove-wantlist'
  releaseLabel?: string
  onConfirm: (dontShowAgain: boolean) => void
  onCancel: () => void
}

export function RemoveConfirmModal({
  action,
  releaseLabel,
  onConfirm,
  onCancel,
}: RemoveConfirmModalProps) {
  // Default UNCHECKED for removes — destructive, keep showing by default
  const [dontShowAgain, setDontShowAgain] = useState(false)

  const isCollection = action === 'remove-collection'
  const target = isCollection ? 'Discogs Collection' : 'Discogs Wantlist'
  const title = isCollection ? 'Remove from your Collection?' : 'Remove from your Wantlist?'

  return (
    <Modal
      open
      onClose={onCancel}
      title={
        <span style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}>
          <i className="bi bi-arrow-left-right" style={{ color: 'var(--stonks-accent-primary)' }} />
          {title}
        </span>
      }
      size="sm"
      footer={
        <>
          <Button variant="secondary" onClick={onCancel}>Cancel</Button>
          <Button variant="danger" onClick={() => onConfirm(dontShowAgain)} autoFocus>
            {isCollection ? 'Remove from Collection' : 'Remove from Wantlist'}
          </Button>
        </>
      }
    >
      <p style={{ margin: '0 0 12px 0', fontSize: '0.9375rem', lineHeight: 1.5 }}>
        {releaseLabel ? <><strong>{releaseLabel}</strong> will be removed from your </> : 'This release will be removed from your '}
        <strong>{target}</strong>. The change writes through to Discogs immediately — same as if you removed it on discogs.com.
        {isCollection && (
          <> Re-adding later won&apos;t restore the original date you owned it.</>
        )}
      </p>
      <label className={styles.checkRow}>
        <input
          type="checkbox"
          checked={dontShowAgain}
          onChange={(e) => setDontShowAgain(e.target.checked)}
        />
        Don&apos;t ask again for {isCollection ? 'Collection removals' : 'Wantlist removals'}
      </label>
    </Modal>
  )
}
